var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"plus-icon",attrs:{"height":"100%","viewBox":"0 0 14 15","fill":"none"}},[_c('path',{attrs:{"d":"M6.97077 13.4385L6.97077 1.79485","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12.7925 7.61663L1.14886 7.61663","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }